import React from 'react';
import { ReactComponent as BackIcon } from '../../../../assets/svg/backArrow.svg';

import Button from '../../../../generic-components/Button';
import { CloseButton, CloseButtonColor, CloseButtonSize } from '../../../../DesignSystem/LiliCloseButton/CloseButton';

interface IProps{
    onBackClick: () => void
    onCloseClick: () => void
    hideBackIcon?: boolean
    hideCloseIcon?: boolean
}
export const LoginHelpNavBar = ({
  onBackClick, onCloseClick, hideBackIcon, hideCloseIcon,
}: IProps) => (
  <div className=' flex w-full h-[70px] absolute top-0 left-0 items-center justify-between px-[38px]'>

    {
        // Remove opacity and disable prop to bring back the back button
          !hideBackIcon
              && (
              <Button
                className='left-0 opacity-0'
                id='s'
                onClick={onBackClick}
                childElement={<BackIcon />}
                disable
              />
              )

    }
    {
          !hideCloseIcon && (

          <CloseButton onClick={onCloseClick} id='close-button' className='right-0' color={CloseButtonColor.Gray} size={CloseButtonSize.Large} />
          )

      }
  </div>
);
